import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'pagination'})
export class PaginationPipe implements PipeTransform {
    transform(value: any[], page:number, perPage: number): any {
        return [ ...value.slice( perPage*(page) , perPage*(page+1)  )]
        // return [...value]
    }
}